/* One-tap "Apply code MANDI" in the cart. Loaded as an asset (not inline) so the
   delegated listener is always bound — an inline <script> inside the drawer snippet
   doesn't execute when the drawer is re-rendered via the Sections API. */
(function () {
  if (window.__soarMandiApplyBound) return;
  window.__soarMandiApplyBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-soar-apply-mandi]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var code = btn.getAttribute('data-code') || 'MANDI';

    fetch('/discount/' + code, { credentials: 'same-origin' })
      .then(function () {
        return fetch('/?sections=cart-drawer').then(function (r) { return r.json(); });
      })
      .then(function (sec) {
        var inner = new DOMParser()
          .parseFromString(sec['cart-drawer'], 'text/html')
          .querySelector('.drawer__inner');
        var cur =
          document.querySelector('#CartDrawer .drawer__inner') ||
          document.querySelector('cart-drawer .drawer__inner');
        if (inner && cur) {
          cur.innerHTML = inner.innerHTML;
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.href = '/discount/' + code + '?redirect=/cart';
      });
  });
})();
